import { render, staticRenderFns } from "./team-admin.vue?vue&type=template&id=0c7a33ba&scoped=true"
import script from "./team-admin.vue?vue&type=script&lang=js"
export * from "./team-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a33ba",
  null
  
)

export default component.exports